module.exports = __webpack_public_path__ + "img/icon.d3d26189.png";